import React from "react";
import { createPortal } from "react-dom";

import "../../../../../components/modal/modalDeleteConfimation.css";
import { FormInput } from "../../../../../components/ui";

const MAX_INPUT_CHARACTER = 50

const ModalRefundSalesConfirmation = ({
  isShowModal,
  onCloseModal,
  onDeleteConfirmed,
  idToDelete,
}) => {
  const [formReason, setFormReason] = React.useState('')

  const handleChangeInput = (evt) => {
    const target = evt.target
    setFormReason(target.value.slice(0, MAX_INPUT_CHARACTER))
  }

  return createPortal(
    isShowModal && (
      <div className="modal-delete-confirmation-container">
        <div className="modal-delete-confirmation-content">
          <header className="modal-delete-confirmation-header">
            <h2 className="modal-delete-confirmation-header-title">
              Konfirmasi Retur Penjualan
            </h2>
            <button
              className="modal-delete-confirmation-close-header-button"
              onClick={onCloseModal}
            >
              &times;
            </button>
          </header>
          <main className="modal-delete-confirmation-main">
            <div className="py-3">
              <p className="mt-0 mb-3">Apakah anda ingin retur transaksi tersebut?</p>
              <FormInput
                type="text"
                placeholder="Tuliskan alasannya...."
                value={formReason}
                onChange={handleChangeInput}
              />
              <span
                className={[
                  'block text-sm',
                  formReason.length >= MAX_INPUT_CHARACTER ? 'text-error' : 'text-neutral'
                ].join(' ')}
                style={{ textAlign: 'right' }}
              >
                {formReason.length} / {MAX_INPUT_CHARACTER}
              </span>
            </div>
          </main>
          <footer className="modal-delete-confirmation-footer">
            <button
              className="modal-delete-confirmation-button"
              onClick={() => {
                onDeleteConfirmed({
                  refundId: idToDelete,
                  refundReason: formReason,
                });
              }}
            >
              Retur
            </button>
            <button
              className="modal-delete-confirmation-close-button"
              onClick={onCloseModal}
            >
              Batal
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalRefundSalesConfirmation;
